module.exports = __webpack_public_path__ + "img/icon-tools.81019594.png";